import { Box, Container, Grid, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#000000",

  "& .lpl_viewcon": {
    position: "relative",
    backgroundColor: "#000000",
    paddingTop: "100px",
    color: "#ffffff",
    display: "flex",
    justifyContent: "center",
    zIndex: 999,
    [theme.breakpoints.down("md")]: {
      padding: "2rem 16px",
    },
  },

  "& .lpl_text_pr": {
    fontWeight: 600,
    fontSize: "3.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
}));

function Banner() {
  const Navigate = useNavigate();
  return (
    <MainView>
      <Container maxWidth={"lg"} className="lpl_viewcon">
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          flexWrap={"wrap-reverse"}
        >
          <Grid item xs={12} md={8}>
            <Typography mb={3} variant="h1" className="lpl_text_pr">
              If you want to know about CRM just contact us !
            </Typography>
            <GlobalButton
              variant={"outlined"}
              btnText={"Join Now"}
              handleClickBtn={() => Navigate("/sign-up")}
              styleProps={{
                color: "#ffffff",
                border: "2px solid #ffffff",
                height: 45,
                width: 200,
              }}
            />
          </Grid>
          <Grid item xs={12} md={4} height={"inherit"}>
            <img src={allImages.landingAboutusMain} width={"100%"} />
          </Grid>
        </Grid>
      </Container>
    </MainView>
  );
}

export default Banner;
